import { render, staticRenderFns } from "./FieldPhoneNumber.vue?vue&type=template&id=67c0e344&"
import script from "./FieldPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./FieldPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports